// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2VUBA","itemTitle":"ClientEmergencyInfo_itemTitle__oFNcu","itemText":"ClientEmergencyInfo_itemText__30VOY"};